import React from "react";
import Icon from "src/icons";

const SearchSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="a"
        d="M22.754 21.559l-4.821-4.82A8.963 8.963 0 0 0 20 11a9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9 8.963 8.963 0 0 0 5.74-2.067l4.82 4.82a.845.845 0 0 0 1.195 0 .85.85 0 0 0-.001-1.194zm-8.909-3.82c-.9.381-1.856.573-2.845.573a7.296 7.296 0 0 1-5.17-2.142A7.296 7.296 0 0 1 3.687 11 7.296 7.296 0 0 1 5.83 5.83 7.296 7.296 0 0 1 11 3.687a7.296 7.296 0 0 1 5.17 2.142A7.296 7.296 0 0 1 18.312 11a7.296 7.296 0 0 1-2.142 5.17 7.27 7.27 0 0 1-2.325 1.568z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <g fill="#fff" fillOpacity="1" mask="url(#b)">
        <circle cx="60" cy="60" r="60" transform="translate(-44 -44)" />
      </g>
    </g>
  </svg>
);

const SearchSvg1 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="a1"
        d="M22.754 21.559l-4.821-4.82A8.963 8.963 0 0 0 20 11a9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9 8.963 8.963 0 0 0 5.74-2.067l4.82 4.82a.845.845 0 0 0 1.195 0 .85.85 0 0 0-.001-1.194zm-8.909-3.82c-.9.381-1.856.573-2.845.573a7.296 7.296 0 0 1-5.17-2.142A7.296 7.296 0 0 1 3.687 11 7.296 7.296 0 0 1 5.83 5.83 7.296 7.296 0 0 1 11 3.687a7.296 7.296 0 0 1 5.17 2.142A7.296 7.296 0 0 1 18.312 11a7.296 7.296 0 0 1-2.142 5.17 7.27 7.27 0 0 1-2.325 1.568z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b1" fill="#fff">
        <use xlinkHref="#a1" />
      </mask>
      <g fill="#fff" fillOpacity="1" mask="url(#b1)">
        <circle cx="60" cy="60" r="60" transform="translate(-44 -44)" />
      </g>
    </g>
  </svg>
);
const SearchSvg2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="a2"
        d="M22.754 21.559l-4.821-4.82A8.963 8.963 0 0 0 20 11a9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9 8.963 8.963 0 0 0 5.74-2.067l4.82 4.82a.845.845 0 0 0 1.195 0 .85.85 0 0 0-.001-1.194zm-8.909-3.82c-.9.381-1.856.573-2.845.573a7.296 7.296 0 0 1-5.17-2.142A7.296 7.296 0 0 1 3.687 11 7.296 7.296 0 0 1 5.83 5.83 7.296 7.296 0 0 1 11 3.687a7.296 7.296 0 0 1 5.17 2.142A7.296 7.296 0 0 1 18.312 11a7.296 7.296 0 0 1-2.142 5.17 7.27 7.27 0 0 1-2.325 1.568z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b2" fill="#fff">
        <use xlinkHref="#a2" />
      </mask>
      <g fill="#fff" fillOpacity="1" mask="url(#b2)">
        <circle cx="60" cy="60" r="60" transform="translate(-44 -44)" />
      </g>
    </g>
  </svg>
);
export const SearchIconHome = (props) => {
  return <Icon component={SearchSvg} {...props} />;
};

export const SearchIconAllOrg = (props) => {
  return <Icon component={SearchSvg1} {...props} />;
};

export const SearchIcon = (props) => {
  return <Icon component={SearchSvg2} {...props} />;
};
